<mat-dialog-content>
  <h2 class="text-black" style="font-weight: bold">
    {{ data.title }}
  </h2>
  <span>
    {{ data.description }}
  </span>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-flat-button [mat-dialog-close]="false">
    {{ data.dismissButtonText }}
  </button>
  <button
    mat-flat-button
    [color]="data.affirmButtonColor ?? 'primary'"
    [mat-dialog-close]="true"
  >
    {{ data.affirmButtonText }}
  </button>
</mat-dialog-actions>
